module.exports = __webpack_public_path__ + "img/CM-SS-25-Mitsubishi-Established.040b0408.jpg";